import { xcss, Box } from '@atlaskit/primitives';
import { FormattedMessage } from 'react-intl';
import { useInfo, useToken } from '../../../../../Flow/ConsentContextProvider';
import { getForgeMcpAppName } from '#definitions/consent-info';
import { headlineMessages } from '../messages';

const headlineTextStyles = xcss({
  margin: 'space.0',
  font: 'font.heading.large',
  color: 'color.text',
});

interface HeaderProps {
  product?: string;
}

const Header = ({ product = 'Atlassian' }: HeaderProps) => {
  const { clientName } = useToken();
  const info = useInfo();
  const forgeAppName = getForgeMcpAppName(info);

  return (
    <Box as="h1" xcss={headlineTextStyles}>
      <FormattedMessage
        {...(forgeAppName
          ? headlineMessages.forgeAppTitle
          : headlineMessages.title)}
        values={{ requestingParty: clientName, product, appName: forgeAppName }}
      />
    </Box>
  );
};

export default Header;
